const typesLivraison = new Map()
typesLivraison.set('SERVICE_AUTO', "Service à l'auto")
typesLivraison.set('LIVRAISON_ETABLISSEMENT', "Livraison à l'établissement")
typesLivraison.set('LIVRAISON_SUCCURSALE', 'Livraison en succursale')

const noteDemandeur = new Map()
noteDemandeur.set(
  'QUANTITE_MODIFIEE_PRODUIT_NON_DISPONIBLE',
  'Quantité modifiée ou produit non disponible'
)
noteDemandeur.set('UNITE_CAISSE_ERRONEE', 'Unité de vente de caisse erronée')
noteDemandeur.set(
  'LIVRAISON_MODIFIEE',
  'Changement aux instructions de livraison'
)

const raisonRejetCommande = new Map()
raisonRejetCommande.set(
  'NO_CLIENT_ERRONE',
  'Absence du numéro de client et/ou erroné'
)
raisonRejetCommande.set('NO_CLIENT_INEXACT', 'No de client inexact')
raisonRejetCommande.set(
  'AUCUNE_MODALITE_PAIEMENT',
  'Ce client ne possède pas de modalités de paiement.'
)
raisonRejetCommande.set(
  'UNITE_CAISSE',
  "Unité de vente de caisse ne correspond pas à l''unité indiqué dans notre système."
)
raisonRejetCommande.set('PRODUIT_NON_DISPONIBLE', 'Produit non disponible')
raisonRejetCommande.set(
  'COORDONNEE_MANQUANTE',
  'Coordonnées manquantes ou incorrectes pour ce client'
)
raisonRejetCommande.set(
  'NUMERO_ACHETEUR_REQUIS',
  "Numéro d''autorisation requis pour ce client"
)
raisonRejetCommande.set('CARTE_CREDIT_REFUSEE', 'Carte de crédit refusée')
raisonRejetCommande.set('LIMITE_CREDIT_DEPASSEE', 'Limite de crédit dépassée')
raisonRejetCommande.set(
  'DEPASSEMENT_DELAI_COMMANDE',
  'Dépassement du délai de commande autorisé de 7 jours'
)
raisonRejetCommande.set('PAIEMENT_AVANCE_REFUSE', "Paiement d''avance refusé")
raisonRejetCommande.set(
  'CLIENT_SANS_MODALITE_PAIEMENT',
  'Client sans modalité de paiement'
)
raisonRejetCommande.set(
  'CLIENT_SANS_INSTRUCTION_LIVRAISON',
  'Client sans instruction de livraison et sans modalité de paiement'
)
raisonRejetCommande.set('RAISON_AUTRE', 'Autre raison')

const journeesLivraison = new Map()
journeesLivraison.set('LUNDI', 'Lundi')
journeesLivraison.set('MARDI', 'Mardi')
journeesLivraison.set('MERCREDI', 'Mercredi')
journeesLivraison.set('JEUDI', 'Jeudi')
journeesLivraison.set('VENDREDI', 'Vendredi')
journeesLivraison.set('SAMEDI', 'Samedi')
journeesLivraison.set('DIMANCHE', 'Dimanche')
journeesLivraison.set('LUNDI_MARDI', 'Lundi et mardi')
journeesLivraison.set('LUNDI_MERCREDI', 'Lundi et mercredi')
journeesLivraison.set('LUNDI_JEUDI', 'Lundi et jeudi')
journeesLivraison.set('LUNDI_VENDREDI', 'Lundi et vendredi')
journeesLivraison.set('MARDI_MERCREDI', 'Mardi et mercredi')
journeesLivraison.set('MARDI_JEUDI', 'Mardi et jeudi')
journeesLivraison.set('MARDI_VENDREDI', 'Mardi et vendredi')
journeesLivraison.set('MERCREDI_JEUDI', 'Mercredi et jeudi')
journeesLivraison.set('MERCREDI_VENDREDI', 'Mercredi et vendredi')
journeesLivraison.set('JEUDI_VENDREDI', 'Jeudi et vendredi')

const statutsCommandeIP = new Map()
statutsCommandeIP.set('BROUILLON', 'Brouillon')
statutsCommandeIP.set('EN_ATTENTE_TRAITEMENT', 'En attente de traitement')
statutsCommandeIP.set('EN_TRAITEMENT', 'En traitement')
statutsCommandeIP.set('CONFIRMEE', 'Confirmée')
statutsCommandeIP.set('REJETEE', 'Rejetée')
statutsCommandeIP.set('ANNULEE', 'Annulée')
statutsCommandeIP.set(
  'APPROUVEE_PAR_TITULAIRE_PERMIS',
  'Approuvée par le titulaire de permis'
)
statutsCommandeIP.set(
  'REFUSEE_PAR_TITULAIRE_PERMIS',
  'Refusée par le titulaire de permis'
)

const statutsCommandeIPPourRecherche = new Map()
statutsCommandeIPPourRecherche.set('BROUILLON', 'Brouillon')
statutsCommandeIPPourRecherche.set(
  'EN_ATTENTE_TRAITEMENT',
  'En attente de traitement'
)
statutsCommandeIPPourRecherche.set('EN_TRAITEMENT', 'En traitement')
statutsCommandeIPPourRecherche.set('CONFIRMEE', 'Confirmée')
statutsCommandeIPPourRecherche.set('REJETEE', 'Rejetée')
statutsCommandeIPPourRecherche.set('ANNULEE', 'Annulée')

const typesClient = new Map()
typesClient.set('TITULAIRE_POUR_REVENTE', 'Titulaire de permis')
typesClient.set('AGENT_PROMOTIONNEL', 'Agent promotionnel')
typesClient.set('PART_USAGE_PERSONNEL', 'Particulier/entreprise')
typesClient.set('BOUTIQUE_HORS_TAXE', 'Boutique hors taxe')
typesClient.set('POUVOYEUR_DE_NAVIRE', 'Pourvoyeur de navire')
typesClient.set('LIEU_DE_CULTE', 'Lieu de culte')
typesClient.set(
  'GROUPE_ACHAT_OU_CLUB_OENOPHILE',
  'Groupe achat ou club oenophile'
)

// TODO DF: mettre les bonnes vakeurs
const typesClientJDE = new Map()
typesClientJDE.set('01', 'Titulaire de permis')
typesClientJDE.set('10', 'Agent promotionnel')
typesClientJDE.set('02', 'Particulier')
typesClientJDE.set('12', 'Particulier')
typesClientJDE.set('15', 'Boutique hors taxe')
typesClientJDE.set('19', 'Boutique hors taxe')
typesClientJDE.set('14', 'Pourvoyeur de navire')
typesClientJDE.set('06', 'Lieu de culte')
typesClientJDE.set('16', 'Groupe achat ou club oenophile')

const typesCarteCredit = new Map()
typesCarteCredit.set('VISA', 'Visa')
typesCarteCredit.set('MASTER_CARD', 'Master card')
typesCarteCredit.set('AMERICAN_EXPRESS', 'American expresss')

const typesCarteCreditAgent = new Map()
typesCarteCreditAgent.set('V', 'Visa')
typesCarteCreditAgent.set('M', 'Master card')
typesCarteCreditAgent.set('AMEX', 'American expresss')

const formatsBouteille = new Map()
formatsBouteille.set('MILLILITRE', 'ML'), formatsBouteille.set('LITRE', 'L')

const typeContenant = new Map()
typeContenant.set('BOUTEILLE_HDPE', 'Bouteille HDPE-6 (code recyclage 2)')
typeContenant.set('BOUTEILLE_PET', 'Bouteille PET-4 (code recyclage 1)')
typeContenant.set('CARTON_ONDULE', 'Carton ondulé/plastique stratifié')
typeContenant.set('CONTENANT_LLDPE', 'Contenant LLDPE')
typeContenant.set('CONTENANT_ALUMINIUM', 'Contenant aluminium')
typeContenant.set('CONTENANT_ASEPTIQUE', 'Contenant aseptique tétrapak')
typeContenant.set('CONTENANT_CERAMIQUE', 'Contenant céramique')
typeContenant.set('CONTENANT_ACIER', "Contenant d'acier")
typeContenant.set('CONTENANT_VERRE_CLAIR', 'Contenant de verre clair')
typeContenant.set('CONTENANT_VERRE_COLORE', 'Contenant de verre coloré')
typeContenant.set('KIT_SHOOTER', 'Kit shooter')

const devises = new Map()
devises.set('CAD', 'CAD')
devises.set('USD', 'USD')
devises.set('XEU', 'EUR')

const typesPrix = new Map()
typesPrix.set('PRIX_FOURNISSEUR', 'Prix fournisseur (à la caisse)')
typesPrix.set('PRIX_DETAIL', 'Vente (à la bouteille)')

export {
  devises, formatsBouteille, journeesLivraison, noteDemandeur,
  raisonRejetCommande, statutsCommandeIP, statutsCommandeIPPourRecherche, typeContenant, typesCarteCredit, typesCarteCreditAgent, typesClient,
  typesClientJDE, typesLivraison, typesPrix
}

